'use client';

import { c as _c } from "react/compiler-runtime";
import type { BigIntish, Fetchable } from '@morpho-org/blue-sdk';
import { isDefined } from '@morpho-org/morpho-ts';
import { CellSimpleText } from '@morpho-org/ui-v6/server';
import { formatISO9075, fromUnixTime } from 'date-fns';
import { memo, useSyncExternalStore } from 'react';
export interface TimestampCellProps {
  timestamp: Fetchable<BigIntish>;
}
const subscribe = () => () => {};
const getSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * `yyyy-MM-dd HH:mm:ss` in UTC — the same shape `formatISO9075` produces in the
 * local timezone, so the hydration render is byte-identical to the server HTML.
 */
const formatUtc = (date: Date) => date.toISOString().slice(0, 19).replace('T', ' ');

/**
 * Rows in server-prefetched tables render on a UTC server and hydrate in the
 * viewer's timezone; formatting local time on both sides would mismatch on every
 * row. Hydration therefore renders UTC and switches to local time once mounted.
 */
export function TimestampCell(t0) {
  const $ = _c(8);
  const {
    timestamp
  } = t0;
  const isMounted = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  if (!isDefined(timestamp)) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CellSimpleText>-</CellSimpleText>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let T0;
  let t1;
  if ($[1] !== isMounted || $[2] !== timestamp) {
    const date = fromUnixTime(Number(timestamp));
    T0 = CellSimpleText;
    t1 = isMounted ? formatISO9075(date) : formatUtc(date);
    $[1] = isMounted;
    $[2] = timestamp;
    $[3] = T0;
    $[4] = t1;
  } else {
    T0 = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[5] !== T0 || $[6] !== t1) {
    t2 = <T0>{t1}</T0>;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export default memo(TimestampCell);